import React from 'react'
import TrackableContext from './TrackableContext'
import PropTypes from 'prop-types'

const Trackable = ({ url, children, httpMethod, disable }) => {
  return (
    <TrackableContext.Consumer>
      {({ update, get, trackManually }) => {
        return children({
          trackManually,
          getCurrTrackedVal: trackingKey => get(trackingKey),
          updateToTrack: (key, params) => {
            if (!disable) {
              update(key, {
                ...params,
                url,
                method: httpMethod
              })
            }
          }
        })
      }}
    </TrackableContext.Consumer>
  )
}

Trackable.defaultProps = {
  httpMethod: 'post'
}

Trackable.propTypes = {
  name: PropTypes.string,
  children: PropTypes.func,
  url: PropTypes.string,
  httpMethod: PropTypes.string,
  disable: PropTypes.bool
}

export default Trackable
